<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div *ngIf="isInvalid || isFinanzamtnummerMissing" class="col-sm-12 col-lg-12 p-0 mb-5x">
    <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.STEUERNUMMER.WARNUNG' | translate" type="danger">
    </common-ui-card>
  </div>
  <div class="form-row">
    <label [ngClass]="narrowInputFields ? 'col-sm-8' : 'col-sm-4'"
           class="col-form-label"
           for="finanzamtnummer{{index}}">
      {{ 'COMMON_UI.STEUERNUMMER.FINANZAMTNUMMER' | translate }}
    </label>
    <div [ngClass]="narrowInputFields ? 'col-sm-4' : 'col-sm-8'">
      <input (change)="changeWarningVisibility()"
             (keyup)="formatSteuernummer()"
             (ngModelChange)="formatSteuernummer()"
             [checkAdditionalControls]="['steuernummer']"
             class="form-control"
             formControlName="finanzamtnummer"
             datevMessagePath="finanzamtnummer{{objectId}}"
             id="finanzamtnummer{{index}}"
             type="text"
             utilsCheckValidity
             utilsControlState
             utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>
  <div class="form-row">
    <label [ngClass]="narrowInputFields ? 'col-sm-8' : 'col-sm-4'"
           class="col-form-label"
           for="steuernummer{{index}}">
      {{ steuernummerLabelTranslation }}
    </label>
    <div [ngClass]="narrowInputFields ? 'col-sm-4' : 'col-sm-8'">
      <input (change)="changeWarningVisibility()"
             [checkAdditionalControls]="['finanzamtnummer']"
             [mask]="steuerMask"
             [prefix]="prefix"
             class="form-control"
             datevMessagePath="steuernummer{{objectId}}"
             formControlName="steuernummer"
             id="steuernummer{{index}}"
             placeHolderCharacter="-"
             showMaskTyped="true"
             type="text"
             utilsCheckValidity
             utilsControlState
             utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>
</form>
